export default {
  message: {
    hello: "Hello, world!",
  },
};
